import React from 'react';
import { router } from '@libs/mvvm';
import Bind from 'lodash-decorators/bind';

interface IProps
    extends React.DetailedHTMLProps<
        React.AnchorHTMLAttributes<HTMLAnchorElement>,
        HTMLAnchorElement
    > {
    path: string;
    dynamicPath?: string;
    params?: IPlainObject;
    onClick?: (event: Event) => void;
}

let sameProductHandler: ((path: string) => boolean) | null = null;

export function setSameProductHandler(func: typeof sameProductHandler) {
    if (typeof func === 'function') {
        sameProductHandler = func;
        return;
    }

    throw new Error("sameProductHandler must function !!!")
}

export class A extends React.Component<IProps, any> {
    @Bind
    private handelClick(e) {
        this.props?.onClick?.(e);

        e.stopPropagation();
        // onclick时，阻止a标签的href生效
        if (e.metaKey) {
            return false;
        }
        if (this.props.target === '_blank') {
            // 如果要求新页面打开
            return false;
        }
        e.preventDefault();

        const path = this.props.dynamicPath || this.props.path;

        if (window.location.pathname === path) {
            window.location.href = router.getUrlString(path, this.props.params);
            return;
        }

        let sameProuductFunc = typeof sameProductHandler === 'function'
            ? sameProductHandler
            : this.defaultSameProduct;

        try {
            if (!sameProuductFunc(path)) {
                window.location.href = router.getUrlString(path, this.props.params);
                return;
            }
        } catch (err) {
            console.error(err);
        }

        router.push(this.props.path, this.props.params);
    }

    @Bind
    private defaultSameProduct(path: string) {
        const isWorkBench = this.isWorkbenchOrGit(window.location.pathname) && this.isWorkbenchOrGit(path);

        if (!isWorkBench &&
            this.getProductNameByUrl(path) !==
            this.getProductNameByUrl(window.location.pathname)) {
            return false;
        }

        return true;
    }

    @Bind
    private isWorkbenchOrGit(path) {
        if (/^\/?web\/workbench\//.test(path)) {
            return true;
        }

        if (/^\/?git\//.test(path)) {
            return true;
        }

        return false;
    }

    @Bind
    private getProductNameByUrl(path: string) {
        if (!path) return '';

        if (path[0] !== '/') {
            path = '/' + path;
        }
        return path.split('/')[2] || '';
    }

    public render() {
        const hrefPath = this.props.dynamicPath || this.props.path;
        const { path, dynamicPath, params, children, ...restProps } =
            this.props;
        return (
            <a
                {...restProps}
                href={router.getUrlString(hrefPath, this.props.params)}
                onClick={this.handelClick}
            >
                {this.props.children}
            </a>
        );
    }
}
